export default "__VITE_ASSET__CEw0TsX3__"